import { AxiosResponse } from 'axios';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { ForexAPI } from 'client/api.config';
import { saveAs } from 'file-saver';
import moment from 'moment';
import { getStatusCode } from 'client/ErrorHandler';
import { DownloadTypes } from './types';
import downloadActions from './actions';

const { request, success, failure } = downloadActions;

export function* download({
  payload,
}: ReturnType<typeof request>): Generator<any, void, any> {
  try {
    const { periodStart } = payload;
    const endpoint = `/v1/exchanges/report?referenceDate=${periodStart}`;

    const response: AxiosResponse<string> = yield call(ForexAPI.get, endpoint);

    const { data: report } = response;

    const csvFile = new Blob([report], {
      type: 'text/csv;charset=utf-8',
    });

    yield saveAs(csvFile, `${moment().format('YYYY-MM-DD')}-report.csv`, {
      autoBom: true,
    });

    yield put(success());
  } catch (error) {
    const statusCode = getStatusCode(error);
    yield put(failure(statusCode));
  }
}

export default function* (): Generator<any, void, any> {
  yield all([takeLatest(DownloadTypes.DownloadRequest, download)]);
}
